import React, { useEffect, useState } from "react";
import "../style/provider-chat-layout.css";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import { useDispatch, useSelector } from "react-redux";
import { getProviderClientList, getAdminUserList } from "../slice/providerChatListSlice";
import { useNavigate, useParams, Outlet } from 'react-router-dom';
import ProviderHeader from "../../provider-header/components/index";
import Pusher from "pusher-js";
import { providerResetNotifications } from "../../provider-navbar/slice/providerNavigationSlice";

const ProviderChatList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
      dispatch(providerResetNotifications());
    }, [dispatch, id]);

  const { providerClients: clients, providerLastMessages, adminUsers, adminLastMessages, loading } = useSelector(
    (state) => state.providerChatList
  );

  console.log("clients", clients);
  console.log("providerLastMessages", providerLastMessages);
  console.log("adminUsers", adminUsers);
  console.log("adminLastMessages", adminLastMessages);

  const providerToken = localStorage.getItem("provider_access_token");
  const token = providerToken;

  const [activeTab, setActiveTab] = useState("client");
  const [filters, setFilters] = useState({
    keyword: "",
    status: ""
  });

  // Debounce search input
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilters((prev) => ({ ...prev, keyword: searchTerm }));
    }, 400); // 400ms debounce

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  // Fetch data based on tab + filter
  useEffect(() => {
    if (activeTab === "client") {
      dispatch(getProviderClientList({ filters, token }));
    } else {
      dispatch(getAdminUserList({ filters, token }));
    }
  }, [dispatch, activeTab, filters, token]);

      useEffect(() => {
    if (!token) return;
  
    const pusher = new Pusher("71055cc21a087085dc31", {
      cluster: "ap2",
      forceTLS: true,
      authEndpoint: `${process.env.REACT_APP_BACKEND_URL}/pusher/auth`,
    });
  
    // Subscribe to all chat channels from lastMessages
    const allChats = [...(providerLastMessages || []), ...(adminLastMessages || [])];
  
    const channels = [];
  
    allChats.forEach((chat) => {
      const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);
  
      chatChannel.bind("App\\Events\\MessageSent", (data) => {
        dispatch(providerResetNotifications());
        // Optionally: Only update if message is for the current user
        const currentUserId = localStorage.getItem("user_id");
        const currentUserType = "Icommunetech\\Provider\\Models\\Provider";
  
        const isToMe =
          data.message.to_id.toString() === currentUserId &&
          data.message.to_type === currentUserType;
  
        if (isToMe) {
          dispatch(providerResetNotifications());
          // Refresh the last messages list
          if (activeTab === "client") {
            dispatch(getProviderClientList({ filters, token }));
          } else {
            dispatch(getAdminUserList({ filters, token }));
          }
        }
      });
  
      channels.push(chatChannel);
    });
  
    return () => {
      channels.forEach((channel) => {
        channel.unbind_all();
        channel.unsubscribe();
      });
      pusher.disconnect();
    };
  }, [providerLastMessages, adminLastMessages, activeTab, dispatch, filters, token]);

  useEffect(() => {
    if (!token) return;
  Pusher.logToConsole = true;
    const pusher = new Pusher("71055cc21a087085dc31", {
      cluster: "ap2",
      forceTLS: true,
      authEndpoint: `${process.env.REACT_APP_BACKEND_URL}/pusher/auth`,
    });
  
    // const chatChannel = pusher.subscribe(`private-chat_${chat.chat_id}`);
  
    // 🔹 Subscribe to the global chat room channel
    const globalChannel = pusher.subscribe("private-chat_room");
  
    globalChannel.bind("App\\Events\\ChatRoomCreated", (data) => {
      console.log("ChatRoomCreated event received:", data);
  dispatch(providerResetNotifications());
       if (activeTab === "client") {
        dispatch(getProviderClientList({ filters, token }));
      } else {
        dispatch(getAdminUserList({ filters, token }));
      }
    });
  
    return () => {
      globalChannel.unbind_all();
      globalChannel.unsubscribe();
      pusher.disconnect();
    };
  }, [activeTab, dispatch, filters, token]);

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    setFilters({ keyword: "", status: "" }); // clear filters on switch
    setSearchTerm("");
    navigate(`/provider/chat/${tab}`);
  };

//   const renderList = activeTab === "provider" ? providers : adminUsers;
//   const recentList = activeTab === "provider" ? clientLastMessages : adminLastMessages;

  return (
    <>
      <ProviderHeader />
      <div className="chat-layout">
        <div className="chat-sidebar">
          <div className="tab-buttons">
            <button
              className={activeTab === "client" ? "active" : ""}
              onClick={() => handleTabSwitch("client")}
            >
              Client
            </button>
            <button
              className={activeTab === "admin" ? "active" : ""}
              onClick={() => handleTabSwitch("admin")}
            >
              Admin
            </button>
          </div>

          {/* Search input */}
          <div style={{ padding: "0 10px 10px" }}>
            <input
              type="text"
              placeholder={`Search ${activeTab === "client" ? "Client" : "Admin"}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "8px",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
          </div>

{/* Client Section */}
{activeTab === "client" && (
  <>
    {providerLastMessages?.length > 0 && (
      <div className="recent-chats-section" style={{ padding: "0 10px" }}>
        <h4 style={{ marginBottom: "8px" }}>Recent Chats</h4>
        {providerLastMessages.map((user) => {
          const targetId = user.from_type === "Icommunetech\\Provider\\Models\\Provider"
            ? user.to_id
            : user.from_type === "Icommunetech\\Client\\Models\\Client"
              ? user.from_id
              : null;

              const displayName = user.from_type === "Icommunetech\\Provider\\Models\\Provider"
                ? user.to_name
                : user.from_type === "Icommunetech\\Client\\Models\\Client"
                  ? user.from_name
                  : "";
            return (
              <div
                key={`recent-provider-${targetId}`}
                className={`chat-list-item ${id === String(targetId) ? "active" : ""}`}
                onClick={() => navigate(`/provider/chat/client/${targetId}/${user.chat_id}?name=${encodeURIComponent(displayName)}`)}
              >
              <img src={IC_logo} alt={user.name} className="chat-avatar" />
              <div className="chat-list-details">
                <div className="chat-name">
                  {user.from_type === "Icommunetech\\Provider\\Models\\Provider" ? user.to_name :
                  user.from_type === "Icommunetech\\Client\\Models\\Client" ? user.from_name : ""}
                </div>
                <div className="chat-status">
                  Last message: {
                    user.message 
                      ? user.message 
                      : user.file_path 
                        ? "📎 Attachment" 
                        : "No message"
                  }
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}

    <div className="all-users-section" style={{ padding: "0 10px" }}>
      <h4 style={{ margin: "16px 0 8px" }}>All Clients</h4>
      {clients.map((user) => (
        <div
          key={`provider-${user.id}`}
          className={`chat-list-item ${id === String(user.id) ? "active" : ""}`}
          onClick={() => navigate(`/provider/chat/client/${user.id}/-?name=${encodeURIComponent(user.first_name)}`)}
        >
          <img src={IC_logo} alt={user.company_name || user.name} className="chat-avatar" />
          <div className="chat-list-details">
            <div className="chat-name">{user.first_name} {user.last_name}</div>
            <div className="chat-status">Status: {user.status || "active"}</div>
          </div>
        </div>
      ))}
    </div>
  </>
)}

{/* Admin Section */}
{activeTab === "admin" && (
  <>
    {adminLastMessages?.length > 0 && (
      <div className="recent-chats-section" style={{ padding: "0 10px" }}>
        <h4 style={{ marginBottom: "8px" }}>Recent Chats</h4>
        {adminLastMessages.map((user) => {
          const targetId = user.from_type === "App\\Models\\User"
            ? user.from_id
            : user.from_type === "Icommunetech\\Provider\\Models\\Provider"
              ? user.to_id
              : null;

              const displayName = user.from_type === "App\\Models\\User"
                ? user.from_name
                : user.from_type === "Icommunetech\\Provider\\Models\\Provider"
                  ? user.to_name
                  : "";
                  return(
          <div
            key={`recent-admin-${targetId}`}
            className={`chat-list-item ${id === String(targetId) ? "active" : ""}`}
            onClick={() => navigate(`/provider/chat/admin/${targetId}/${user.chat_id}?name=${encodeURIComponent(displayName)}`)}
          >
            <img src={IC_logo} alt={user.name} className="chat-avatar" />
            <div className="chat-list-details">
              <div className="chat-name">
                  {user.from_type === "App\\Models\\User" ? user.from_name :
                  user.from_type === "Icommunetech\\Provider\\Models\\Provider" ? user.to_name : ""}
                </div>
              <div className="chat-status">
                  Last message: {
                    user.message 
                      ? user.message 
                      : user.file_path 
                        ? "📎 Attachment" 
                        : "No message"
                  }
                </div>
            </div>
          </div>
                  );
        })}
      </div>
    )}

    <div className="all-users-section" style={{ padding: "0 10px" }}>
      <h4 style={{ margin: "16px 0 8px" }}>All Admins</h4>
      {adminUsers.map((user) => (
        <div
          key={`admin-${user.id}`}
          className={`chat-list-item ${id === String(user.id) ? "active" : ""}`}
          onClick={() => navigate(`/provider/chat/admin/${user.id}/-?name=${user.name}`)}
        >
          <img src={IC_logo} alt={user.company_name || user.name} className="chat-avatar" />
          <div className="chat-list-details">
            <div className="chat-name">{user.company_name || user.name}</div>
            <div className="chat-status">Status: {user.status || "active"}</div>
          </div>
        </div>
      ))}
    </div>
  </>
)}
        </div>

        <div className="chat-content">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default ProviderChatList;
